import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';

export default function PreguntaMenu({
  textoPregunta,
  PreguntasOpciones,
  valorDefault = '',
  numeroPregunta,
  onChangeRespuesta,
  esObligatoria
}) {
  const [selectedValue, setSelectedValue] = useState(valorDefault);

  // 🔁 Sincronizar si valorDefault cambia
  useEffect(() => {
    if (valorDefault !== selectedValue) {
      setSelectedValue(valorDefault);
    }
  }, [valorDefault]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    const tieneContenido = selectedValue !== '';
    const opcionSeleccionada = PreguntasOpciones.find((opcion) => opcion.id === parseInt(selectedValue));
    const contenido = opcionSeleccionada ? [opcionSeleccionada.id, opcionSeleccionada.opcion] : null;

    const respuesta = {
      numeroPregunta,
      tieneContenido,
      contenido,
      esObligatoria
    };

    onChangeRespuesta(respuesta);
  }, [selectedValue, PreguntasOpciones]);

  return (
    <div>
      <div>{textoPregunta}</div>
      <FormControl
        fullWidth
        sx={{
          '& > :not(style)': { m: 1 },
          width: '330px',
          height: '40px'
        }}
      >
        <Select
          displayEmpty
          value={selectedValue}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected === '') {
              return <em>Seleccione una opción</em>;
            }
            return PreguntasOpciones.find((opcion) => opcion.id === parseInt(selected))?.opcion;
          }}
          inputProps={{ 'aria-label': 'Without label' }}
          sx={{
            width: '330px',
            height: '40px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <MenuItem disabled value="">
            <em>Seleccione una opción</em>
          </MenuItem>
          {PreguntasOpciones.map((opcion) => (
            <MenuItem key={opcion.id} value={opcion.id}>
              {opcion.opcion}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div>
        <br />
      </div>
    </div>
  );
}
